import { Get, Set } from "../../../../../Request";
import { useState } from "react";
export const useContract = () => {
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [data, setData] = useState({});
  const [modal, setModal] = useState({
    visible: false,
    data: {},
  });
  const [form, setForm] = useState({});

  const getData = () => {
    setLoading(true);
    Get({
      url: "/contract/show_admin",
    }).then(res => {
      setData(res);
      setLoading(false);
    });
  };
  const changeStatus = async data => {
    setBtnLoading(true);
    await Set({
      url: "/contract/status",
      data: data,
    }).then(res => {
      setData(res);
      setBtnLoading(false);
      getData();
    });
  };

  return {
    data,
    loading,
    getData,
    modal,
    setModal,
    btnLoading,
    setBtnLoading,
    form,
    setForm,
    changeStatus,
  };
};
